import { Search } from '@vtex/shoreline'

import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import styles from '../styles.module.css'

export const NameSearchPanel: React.FC<{
  value: string
  loading: boolean
  onChange: (value: string) => void
}> = ({ value, loading, onChange }) => {
  const { t } = useAPPTranslation()

  return (
    <div className={styles.modalSearch}>
      <Search
        value={value}
        loading={loading}
        messages={{
          placeholder: t('rm:advertiserProducts.addModal.search.placeholder')
        }}
        onChange={event => onChange(event.target.value)}
        onClear={() => onChange('')}
      />
      <p className={styles.searchHint}>
        {t('rm:advertiserProducts.addModal.search.hint')}
      </p>
    </div>
  )
}
